import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { Image } from 'ui/acro'
import VideoPlayer from 'components_v2/VideoPlayer'

const Slides = ({ previewMedia, planId }) => (
  <Fragment>
    {previewMedia.map((media, index) => {
      switch (media.mediaType) {
        case 'video':
          return (
            <div className='swiper-slide' key={index}>
              <VideoPlayer videoId={media.mediaObject.id} planId={planId} />
            </div>
          )
        case 'image':
          return (
            media.mediaObject && (
              <div className='swiper-slide' key={index}>
                <Image src={media.mediaObject.url} />
              </div>
            )
          )
        default:
          break
      }
    })}
  </Fragment>
)

Slides.propTypes = {
  planId: PropTypes.number,
  previewMedia: PropTypes.array
}

export default Slides
